import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";

/* ✅ SAMPLE LOGOS (Replace with your real logos) */
const clients = [
  "https://dprstorage.b-cdn.net/RW/logo/ZUARI%20INFRA.png",
  "https://dprstorage.b-cdn.net/RW/logo/gangothri.png",
  "https://dprstorage.b-cdn.net/RW/logo/DPR.png",
  "https://dprstorage.b-cdn.net/RW/logo/e%20infra.png",
  "https://dprstorage.b-cdn.net/RW/logo/AVANI.png",
  "https://dprstorage.b-cdn.net/RW/logo/CANDEUR.png",
"https://dprstorage.b-cdn.net/RW/logo/KOLLA.png",
"https://dprstorage.b-cdn.net/RW/logo/LACASA.png",
"https://dprstorage.b-cdn.net/RW/logo/haneesh%20logo.png",
// "https://dprstorage.b-cdn.net/RW/logo/PVR%20DEVELOPERS.png",
// "https://dprstorage.b-cdn.net/RW/logo/SHRITHA%20ORTUS.png",
"https://dprstorage.b-cdn.net/RW/logo/SUCHIRINDIA.png",
"https://dprstorage.b-cdn.net/RW/logo/VAMSIRAM%20HOMES.png",
"https://dprstorage.b-cdn.net/RW/logo/VASMIRAM.png",
"https://dprstorage.b-cdn.net/RW/logo/VERDANT.png",
"https://dprstorage.b-cdn.net/RW/logo/VIBRANT%20DEVELOPERS.png",

];

const ClientsLogos = () => {
  return (
    <Box
      sx={{
        py: 10,
        position: "relative",
        overflow: "hidden",

        // 💎 Luxury Gradient Background
        background: `
          linear-gradient(
            135deg,
            #0f63a5 0%,
            #0c4f85 60%,
            #083a63 100%
          )
        `,
      }}
    >
      {/* ✨ Glow Effect */}
      <Box
        sx={{
          position: "absolute",
          top: "-20%",
          left: "-10%",
          width: "600px",
          height: "600px",
          background:
            "radial-gradient(circle, rgba(255,255,255,0.2), transparent 70%)",
          filter: "blur(80px)",
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
        
        {/* HEADER */}
        <Box textAlign="center" mb={6}>
          <Typography
            variant="h3"
            sx={{
              color: "#fff",
              fontWeight: 600,
              mb: 1,
            }}
          >
            Trusted by Industry Leaders
          </Typography>

          <Typography
            sx={{
              color: "rgba(255,255,255,0.8)",
            }}
          >
            We partner with premium brands and high-growth companies
          </Typography>
        </Box>

        {/* LOGOS GRID */}
        <Grid container spacing={4} justifyContent="center">
          {clients.map((logo, i) => (
            <Grid item xs={6} sm={4} md={2} key={i}>
              <Box
                sx={{
                  height: 90,
                  borderRadius: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",

                  backdropFilter: "blur(12px)",
                  background:
                    "linear-gradient(145deg, rgba(255,255,255,0.15), rgba(255,255,255,0.05))",
                  border: "1px solid rgba(255,255,255,0.2)",

                  transition: "all 0.4s ease",

                  // 💎 Hover Luxury Effect
                  "&:hover": {
                    transform: "translateY(-6px) scale(1.05)",
                    boxShadow: "0 15px 40px rgba(0,0,0,0.4)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={logo}
                  alt="client"
                  sx={{
                    maxWidth: "85%",
                    maxHeight: "90px",

                    // 🔥 Logo effect
                    filter: "grayscale(100%) brightness(2)",
                    // opacity: 0.7,

                    transition: "all 0.4s ease",

                    "&:hover": {
                      filter: "grayscale(0%) brightness(1)",
                      opacity: 1,
                    },
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>

      </Container>
    </Box>
  );
};

export default ClientsLogos;